import React from 'react';
import DropdownFilterCell from './DropdownFilterCell';

const UpdatedByFilterCell = (users) => (props) => <DropdownFilterCell {...props} data={users} />;

export default UpdatedByFilterCell;
